import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { RouteParamsRequest } from '#models';
import type { ChatroomDataObject } from '#models/services';
import { routes } from '#routes';

type GetChatroomRequest = paths['/chatrooms/{id}']['get']['parameters']['path'];

export const getChatroom = async ({ routeParams: { id } }: RouteParamsRequest<GetChatroomRequest>) =>
  getNodeApiAxiosInstance().get<ChatroomDataObject, AxiosResponse<ChatroomDataObject>>(routes.chatrooms.get(id));
